import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useTheme,
  Divider,
} from "@mui/material";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import axiosInstance from "../../axiosInstance";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [roles, setRoles] = useState([]);
  const [currentRole, setCurrentRole] = useState(
    localStorage.getItem("role") || "",
  );
  const token = localStorage.getItem("authToken");

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  useEffect(() => {
    if (!token) return;
    axiosInstance
      .get("/users/my-roles", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        setRoles(res.data || []);
        const savedRole = localStorage.getItem("role");
        if (savedRole) setCurrentRole(savedRole);
        else if (res.data.length > 0) setCurrentRole(res.data[0].name);
      })
      .catch((err) => console.error(err));
  }, [token]);

  const handleSwitchRole = (role) => {
    if (!token || role.name === currentRole) return;

    axiosInstance
      .post(
        "/users/switch-role",
        { roleId: role.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        const newToken = res.data.accessToken;

        if (role.name === "User") {
          // Logout User if role is "User"
          localStorage.removeItem("authToken");
          localStorage.removeItem("role");
          setCurrentRole(null);
          window.location.href = "/";
        } else {
          if (newToken) localStorage.setItem("authToken", newToken);
          localStorage.setItem("role", role.name);
          setCurrentRole(role.name);
          window.location.href = "/dashboard";
        }
      })
      .catch((err) => console.error(err));
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("role");
    setCurrentRole(null);
    window.location.href = "/";
  };

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      {/* SEARCH BAR */}
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        <input
          style={{
            flex: 1,
            border: "none",
            padding: "4px 8px",
            background: "transparent",
            color: colors.grey[100],
          }}
          placeholder="Search"
        />
      </Box>

      {/* ICONS */}
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton>
          <SettingsOutlinedIcon />
        </IconButton>

        {/* Roles dropdown */}
        <Box display="flex" alignItems="center">
          <IconButton onClick={handleClick}>
            <PersonOutlinedIcon />
          </IconButton>
          <Typography variant="body2" sx={{ ml: 0.5 }}>
            {currentRole}
          </Typography>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {/* Header */}
          <Typography
            variant="subtitle2"
            sx={{
              px: 2,
              py: 1,
              fontWeight: "bold",
              color: colors.grey[500],
              pointerEvents: "none",
            }}
          >
            Switch Roles
          </Typography>
          <Divider />

          {/* Role options */}
          {roles.map((role) => (
            <MenuItem
              key={role.id}
              onClick={() => handleSwitchRole(role)}
              disabled={role.name === currentRole}
              sx={{
                color:
                  role.name === currentRole
                    ? colors.blueAccent[500]
                    : "inherit",
                fontWeight: role.name === currentRole ? "bold" : "normal",
              }}
            >
              {role.name}
            </MenuItem>
          ))}

          <Divider />
          {/* Logout */}
          <MenuItem
            onClick={handleLogout}
            sx={{ color: colors.redAccent[500], fontWeight: "bold" }}
          >
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Topbar;
